Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "App1033828718",
  {"root":"App1033828718--root"},
  "",
  10,
  "App1033828718"
);

